<template>
  <div>
    <CCol xs="12" md="12" lg="6" class="col-centered update-column">
      <h4 class="card-title">Student</h4>
      <h6 class="card-subtitle"><a href="#">Back to list</a></h6>
      <hr>
      <div style="clear:both"></div>
      <div><label><strong>Student Name</strong> </label></div>
      <input class="form-control" value="AAROON">
      <br>
      <div><label><strong>Student Email</strong></label></div>
      <input class="form-control" value="default@advancedcellnet.com">
      <br>
      <div><label><strong>Parent Name</strong> </label></div>
      <input class="form-control" value="SHAHIRA">
      <br>
      <div><label><strong>Parent Email</strong></label></div>
      <input class="form-control" value="office.shahira@advancedcellnet.com">
      <br>
      <div><label><strong>Parent Phone Number</strong> </label></div>
      <input class="form-control" value="0126240294">
      <br>
      <div><label><strong>Grade</strong></label></div>
      <select class="form-control">
        <option>Form 1/GRADE 7</option>
        <option>Form 2/GRADE 8</option>
        <option>Form 3/GRADE 9</option>
        <option>Form 4/GRADE 10</option>
        <option selected>FORM 5/GRADE 11</option>
    </select>
      <br>
      <div><label><strong>Class Name</strong> </label></div>
      <input class="form-control" value="-">
      <br>
      <div><label><strong>Choose Rate Type</strong></label></div>
      <select class="form-control">
        <option selected>Hourly</option>
        <option>Monthly</option>
    </select>
      <br>
      <input type="submit" value="Save Changes" class="btn btn-success" />
      <br>
    </CCol>
    <br>                
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  }
}
</script>
